<template>
  <!-- Header -->
  <header class="header container-fluid">
    <nav class="navbar navbar-expand-lg header-nav">
      <!-- Left column for the logo -->
      <div class="navbar-header col-4">
        <a id="mobile_btn" href="javascript:void(0);">
          <span class="bar-icon"><i class="fas fa-navicon fa-2x" style="color: black; margin-left: -17px;"></i></span>
        </a>
        <router-link to="/" class="navbar-brand ml-2">
          <img :src="config.base_url_for_Image + main_data" class="img-fluid" alt="Logo"
            style="height: 40px; display: inline;" />
        </router-link>

      </div>
      <!-- Right column for other items -->
      <div class="col-lg-8">
        <div class="main-menu-wrapper">
          <div class="menu-header" style="width:auto;">
            <a id="menu_close" class="menu-close" href="javascript:void(0);">
              <i class="fas fa-times"></i>
            </a>
            <router-link to="/" class="navbar-brand ml-2">
              <img :src="config.base_url_for_Image + main_data" class="img-fluid" alt="Logo"
                style="height: 30px; display: inline;" />
            </router-link>

          </div>
          <ul class="main-nav " style="font-size: 16px; float: right; margin-right: 20px;">
            <li style="border: none;">
            </li>
            <li v-if="domainFor === 'City Portal'">
              <router-link to="/hospitals">
                <i class="fas fa-hospital"></i>
                <span @click="menu_close()">Hospitals</span>
              </router-link>
            </li>
            <li>

              <router-link to="/search-doctor">
                <i class="fa fa-user-md ml-1"></i>
                <span @click="menu_close()">Search Doctors</span>
              </router-link>
            </li>

            <li>
              <router-link to="/search">
                <i class="fas fa-stethoscope ml-1"></i>
                <span @click="menu_close()">Doctors by Speciality</span>
              </router-link>
            </li>
            <!-- <li>
              <router-link to="/contact-us">
                <i class="fas fa-phone ml-1"></i> 

                <span @click="menu_close()">Contact Us</span>
              </router-link>

            </li> -->

            <div class="main-nav button-head-nav">
              <router-link v-if="this.username === null" class=" btn btn-secondary btn-sm rounded-pill mt-1 ml-2"
                style="background: #3CB371 !important;" to="/login">Login</router-link>
            </div>

            <li class="nav-item dropdown has-arrow logged-item" v-if="this.username !== null">
              <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
                <span class="user-img">
                  <img class="rounded-circle" v-bind:src="user_image
                    ? config.base_url_for_Image + user_image
                    : user_type === 'doctor'
                      ? loadDoctorImg('Doctor Profile.svg')
                      : loadPatientImg('Patient Profile.svg')
                    " width="31" alt="Darren Elder" style="height: 25px; width: 25px;" />
                </span>
              </a>
              <div class="dropdown-menu mt-3"
                style="max-width: 200px; position: absolute; left: unset; right: 12%; transform: translateX(20%);">
                <div class="user-header" style="display: flex; flex-direction: column; align-items: center;">
                  <!-- <div class="avatar avatar-sm">
                    <img v-bind:src="user_image
                      ? config.base_url_for_Image + user_image
                      : user_type === 'doctor'
                        ? loadDoctorImg('Doctor Profile.svg')
                        : loadPatientImg('Patient Profile.svg')" alt="User Image" class="avatar-img rounded-circle"
                      style="height:30px; width:30px;" />
                  </div> -->
                  <div class="user-text" style="text-align: center;">
                    <h6 style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%;">
                      {{ user_type === 'hospital' ? hospitalName : username }}
                    </h6>
                    <p class="text-muted mb-0">
                      {{ user_type === "doctor" ? "Doctor" : (user_type === "hospital" ? "Hospital" : "Patient") }}
                    </p>

                  </div>
                </div>
                <router-link class="dropdown-item" :to="getDashboardRoute()" @click="menu_close()">Dashboard</router-link>

                <router-link class="dropdown-item"
                  :to="user_type === 'doctor' ? '/doctor/profile-settings' : (user_type === 'hospital' ? '/hospital/hospital-settings' : '/patient/profile')"
                  @click="menu_close()">Profile</router-link>
                <a href="javascript:void(0);" @click="submit_logout(); menu_close()" class="dropdown-item">Logout</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <ul class="nav header-navbar-rht">
        <li class="nav-item contact-item"></li>
      </ul>
    </nav>
  </header>
</template>

<script>
import { mapActions, mapState } from "vuex";
import config from "../../../services/CommonApi";
const doctors_image = require.context("@/assets/img/doctors");
const patients_image = require.context("@/assets/img/patients");
import axios from "axios";
export default {
  data() {
    return {
      main_data: "",
      username: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).username
        : null,
      user_image: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).image
        : null,
      hospitalName: localStorage.getItem("hospitalID")
        ? JSON.parse(localStorage.getItem("hospitalID")).hospital_name
        : '',
      hospitalCity: localStorage.getItem("hospitalID")
        ? JSON.parse(localStorage.getItem("hospitalID")).city
        : '',


      config: config,
      domainFor: "", // Add this variable to store the domain_for value
    };
  },

  mounted() {
    this.get_practitioner_profile();
    var $wrapper = $(".main-wrapper");
    $(".main-nav a").on("click", function (e) {
      if (
        $(this)
          .parent()
          .hasClass("has-submenu")
      ) {
        e.preventDefault();
      }
      if (!$(this).hasClass("submenu")) {
        $("ul", $(this).parents("ul:first")).slideUp(350);
        $("a", $(this).parents("ul:first")).removeClass("submenu");
        $(this)
          .next("ul")
          .slideDown(350);
        $(this).addClass("submenu");
      } else if ($(this).hasClass("submenu")) {
        $(this).removeClass("submenu");
        $(this)
          .next("ul")
          .slideUp(350);
      }
    });
    $("body").append('<div class="sidebar-overlay"></div>');
    $(document).on("click", "#mobile_btn", function () {
      $wrapper.toggleClass("slide-nav");
      $(".sidebar-overlay").toggleClass("opened");
      $("html").addClass("menu-opened");
      $("#task_window").removeClass("opened");
      return false;
    });

    $(document).on("click", "#menu_close", function () {
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
      $("main-wrapper").removeClass("slide-nav");
    });
    $(".main-nav ul li:not(.submenu) a").click(function () {
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
    });
  },
  computed: {
    ...mapState({
      user_type: (state) => state.user.user_type,
    }),
    currentPath() {
      return this.$route.name;
    },
    homeMenu() {
      return (
        this.$route.name == "index" ||
        this.$route.name == "index-5" ||
        this.$route.name == "index-6" ||
        this.$route.name == "index-8" ||
        this.$route.name == "index-7" ||
        this.$route.name == "index-1" ||
        this.$route.name == "index-page" ||
        this.$route.name == "index-2" ||
        this.$route.name == "index-3" ||
        this.$route.name == "index-4"
      );
    },
    doctorMenu() {
      return (
        this.$route.name == "doctor-index" ||
        this.$route.name == "doctor-appointments" ||
        this.$route.name == "schedule-timings" ||
        this.$route.name == "my-patients" ||
        this.$route.name == "messages" ||
        this.$route.name == "invoices" ||
        this.$route.name == "profile-settings" ||
        this.$route.name == "doctor-reviews" ||
        this.$route.name == "doctor-register" ||
        this.$route.name == "doctor-blogs" ||
        this.$route.name == "blog-details" ||
        this.$route.name == "add-blog" ||
        this.$route.name == "edit-blog" ||
        this.$route.name == "add-prescription" ||
        this.$route.name == "edit-prescription" ||
        this.$route.name == "add-billing" ||
        this.$route.name == "edit-billing"
      );
    },
    patientsMenu() {
      return (
        this.$route.name == "doctor-mapgrid" ||
        this.$route.name == "doctor-maplist" ||
        this.$route.name == "doctor-profile" ||
        this.$route.name == "search-doctor" ||
        this.$route.name == "booking" ||
        this.$route.name == "booking-success" ||
        this.$route.name == "checkout" ||
        this.$route.name == "patient-dashboard" ||
        this.$route.name == "favourites" ||
        this.$route.name == "chat" ||
        this.$route.name == "patient-profile-settings" ||
        this.$route.name == "patient-change-password"
      );
    },
    pharmacyMenu() {
      return (
        this.$route.name == "pharmacy" ||
        this.$route.name == "pharmacy-details" ||
        this.$route.name == "pharmacy-search" ||
        this.$route.name == "pharmacy-product" ||
        this.$route.name == "pharmacy-product-description" ||
        this.$route.name == "pharmacy-cart" ||
        this.$route.name == "pharmacy-product-checkout" ||
        this.$route.name == "patient-dashboard" ||
        this.$route.name == "favourites" ||
        this.$route.name == "chat" ||
        this.$route.name == "pharmacy-payment-success"
      );
    },
    pagesMenu() {
      return (
        this.$route.name == "voice-call" ||
        this.$route.name == "video-call" ||
        this.$route.name == "calendar" ||
        this.$route.name == "componentss" ||
        this.$route.name == "invoice-view" ||
        this.$route.name == "logins" ||
        this.$route.name == "blank" ||
        this.$route.name == "patient-register" ||
        this.$route.name == "login" ||
        this.$route.name == "invoices" ||
        this.$route.name == "forgot-password"
      );
    },
    blogMenu() {
      return (
        this.$route.name == "blog-list" ||
        this.$route.name == "blog-grid" ||
        this.$route.name == "blog-details"
      );
    },
    contactusMenu() {
      return (
        this.$route.name == "blog-list" ||
        this.$route.name == "blog-grid" ||
        this.$route.name == "blog-details"
      );
    },
    aboutusMenu() {
      return (
        this.$route.name == "blog-list" ||
        this.$route.name == "blog-grid" ||
        this.$route.name == "blog-details"
      );
    },
  },
  methods: {

    getDashboardRoute() {
      switch (this.user_type) {
        case 'hospital':
          return '/hospital/appointment';
        case 'doctor':
          return '/doctor/dashboard';
        case 'patient':
          return '/patient/dashboard';
        default:
          // Handle other cases or provide a default route
          return '/default-route';
      }
    },


    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://app.bhilwarahealthcare.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].logo;
            this.domainFor = res.data.data[0].domain_for; // Set domainFor here
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "bhilwarahealthcare.in") {
            } else if (window.location.hostname == "localhost") {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://bhilwarahealthcare.in");
            }
          }

          this.$swal.close();
        });
    },


    menu_close() {
      // Code to close the sidebar here
      var $wrapper = $(".main-wrapper");
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
      $wrapper.removeClass("slide-nav");
    },

    ...mapActions(["signOut"]),

    loadDoctorImg(imgPath) {
      return doctors_image("/" + imgPath);
    },

    loadPatientImg(imgPath) {
      return patients_image("./" + imgPath);
    },

    async submit_logout() {
      this.signOut();
      this.$store.dispatch("user/setUserType");
      this.$store.dispatch("user/setUserID");
    },
    dashboard(value) {
      if (value == 1) {
        let router = this.$router.resolve({ path: "/admin/index" });
        window.open(router.href, "_blank");
      } else {
        let router = this.$router.resolve({ path: "/pharmacyadmin/index" });
        window.open(router.href, "_blank");
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/layouts/Header.vue